export interface Box {
    left: number;
    right: number;
    top: number;
    bottom: number;
}

/**
 * Which labels the window's outline runs through: those holding the whole
 * width of one of its two vertical lines, `stroke` wide and centered on the
 * outline's edges, within its height. A line straddling a label's edge isn't
 * counted, since a backing would hide only part of it; the label's padding
 * keeps such a line clear of its text.
 */
export function labelsOverOutline({
    labels,
    outline,
    stroke,
}: {
    labels: readonly Box[];
    outline: Box;
    stroke: number;
}): boolean[] {
    const halfStroke = stroke / 2;
    return labels.map(
        (label) =>
            label.top < outline.bottom &&
            label.bottom > outline.top &&
            [outline.left, outline.right].some(
                (line) =>
                    line - halfStroke >= label.left &&
                    line + halfStroke <= label.right,
            ),
    );
}
